

import React from 'react';

function TaskIcon({ color = 'black', bgColor = 'white' }) {
  return (
    <>
      <svg width="34" height="34" viewBox="0 0 24 25" fill={bgColor} xmlns="http://www.w3.org/2000/svg">
        <path d="M8 5.5H20" stroke={color} stroke-linecap="round" />
        <path d="M4 5.5H4.00898" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
        <path d="M4 12.5H4.00898" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
        <path d="M4 19.5H4.00898" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
        <path d="M8 13H16" stroke={color} stroke-linecap="round" />
        <path d="M8 20H20" stroke={color} stroke-linecap="round" />
      </svg>
    </>
  );
}

export default TaskIcon;
